import React from 'react';

import { Typography } from '@mui/material';

import { formattedShortDate } from '@luxuryescapes/lib-refunds/build/lib/formatDate';

import { formatDateLong, formatDateLongMonthWithMeridiem } from '~/services/TimeService';

const getDateColor = (date: Date) => (date > new Date() ? 'grey.800' : 'red');

type Props = {
  date: string;
  highlightIfPast?: boolean | 'green';
  includeYear?: boolean;
};

const getHighlightIfPastColor = (highlightIfPast: boolean | 'green', date: Date) => {
  if (highlightIfPast === 'green') {
    return 'green';
  }
  return highlightIfPast ? getDateColor(new Date(date)) : '';
};

const DateFormatterDetailed = ({ date, highlightIfPast = false, includeYear = false }: Props) =>
  date && (
    <Typography
      variant="caption"
      color={highlightIfPast ? getHighlightIfPastColor(highlightIfPast, new Date(date)) : ''}
      title={formatDateLongMonthWithMeridiem(new Date(date))}
    >
      {includeYear ? formatDateLong(new Date(date)) : formattedShortDate(new Date(date))}
    </Typography>
  );

export default DateFormatterDetailed;
